<template>
    <div no-body id="print">
        <b-row class="mx-2">
            <b-col>
                <card> 
                    <div slot="header">
                        <b-row >
                            <b-col cols="6">
                                <h1 class="mb-0">Net Worth Statement</h1>
                            </b-col>
                            <b-col cols="6" class="text-right">
                                <!-- <base-button type="primary" icon size="sm" @click.prevent="underDevelopment()">
                                    <span class="btn-inner--text">Send KYC To Customer</span>
                                </base-button> -->
                                <base-button type="primary" icon size="sm" v-b-toggle.collapse-4>
                                    <span class="btn-inner--icon"><i class="fas fa-caret-down"></i></span>
                                </base-button>
                            </b-col>
                        </b-row>
                    </div>
                    <!-- Card body -->
                    <b-collapse id=collapse-4 visible class="mx-6">
                        <div>
                            <h5 class="text-danger"> Note : <br>
                                <i>
                                    1. The blue color value indicated the value filled by customer.
                                </i>
                                <br>
                                <i>
                                    2. The gray color value indicated the value auto calculated by system.
                                </i>
                                <br>
                                <i>
                                    3. If the monthly column is being filled up, the annual value will be auto calculated; Vice versa.
                                </i>
                                <br>
                                <i>
                                    4. Advisory can only edit the column filled up by customer, if monthly column is filled up, advisory can only update the monthly column.
                                </i>
                                <br>
                                <i>
                                    5. For Assets, the customer answer will followed the same value as the advisory answer.
                                </i>
                                <br>
                                <i v-if="saving_info_from_user && net_flow"><b>
                                    6. The auto calculated value from net flow should be RM {{net_flow.annual_total_netflow.toLocaleString(undefined, {minimumFractionDigits: 2})}}
                                </b></i>
                            </h5>
                            <br>
                            <h2>{{customers.customer_name}}</h2>
                            <table style="margin-bottom:20px">
                                <tr class="text-white">
                                    <th></th>
                                    <th style="width:10%">Customer Answer (RM)</th>
                                    <th style="width:10%">Advisory Answer (RM)</th>
                                </tr>
                                <!-- assets -->
                                <template>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td colspan="3"><b>Assets - from Advisor Manual Update</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="3"><b>Assets</b></td>
                                    </tr>
                                    <template>
                                        <tr>
                                            <td colspan="3" class="pl-4"><b>Cash / Cash Equivalents</b>&nbsp;
                                                <base-button type="primary" icon size="sm" @click.prevent="addCustomerAssets('cash_equivalents')">
                                                    <span class="btn-inner--icon"><i class="fa fa-plus"></i></span>
                                                </base-button>
                                                <base-button type="primary" icon size="sm" @click.prevent="saveNetFlowDataToCustomerAssets()">
                                                    <span class="btn-inner--text">Save Inflow as Asset</span>
                                                </base-button>
                                            </td>
                                        </tr>
                                        <tr v-for="(cash_equivalent) in assets.cash_equivalents" :key="'asset_'+cash_equivalent.customer_asset_id">
                                            <td><el-input type="text" min="0" size="small" id="admin-value" v-model="cash_equivalent.asset_title" v-on:input="updateCustomerAssets(cash_equivalent.customer_asset_id, cash_equivalent.asset_title, cash_equivalent.admin_value)"/></td>
                                            <td class="text-gray">{{parseFloat(cash_equivalent.admin_value).toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="cash_equivalent.admin_value" v-on:input="updateCustomerAssets(cash_equivalent.customer_asset_id, cash_equivalent.asset_title, cash_equivalent.admin_value)">
                                                    <template #append>
                                                        <base-button type="primary" icon size="sm" @click.prevent="deleteCustomerAssets(cash_equivalent.customer_asset_id)">
                                                            <span class="fas fa-trash"></span>
                                                        </base-button>
                                                        <base-button v-show="cash_equivalent.asset_title == 'saving from net flow value' && cash_equivalent.admin_value != parseFloat(net_flow.annual_total_netflow.toFixed(2))" 
                                                            type="primary" icon size="sm" @click.prevent="resetCustomerSavingAsset(cash_equivalent.customer_asset_id, cash_equivalent.asset_title, net_flow.annual_total_netflow)">
                                                            <span class="btn-inner--text">Reset</span>
                                                        </base-button>
                                                    </template>
                                                </el-input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pl-4"><b>Total Cash / Cash Equivalents</b></td>
                                            <td><b>{{totalAssetAdminValue.cash_equivalents.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{totalAssetAdminValue.cash_equivalents.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </tr>
                                    </template>
                                    
                                    <template>
                                        <tr>
                                            <td colspan="3" class="pl-4"><b>Investment Assets</b>&nbsp;
                                                <base-button type="primary" icon size="sm" @click.prevent="addCustomerAssets('investment_assets')">
                                                    <span class="btn-inner--icon"><i class="fa fa-plus"></i></span>
                                                </base-button>
                                            </td>
                                        </tr>
                                        <tr v-for="(investment_asset) in assets.investment_assets" :key="'asset_'+investment_asset.customer_asset_id">
                                            <td><el-input type="text" min="0" size="small" id="admin-value" v-model="investment_asset.asset_title" v-on:input="updateCustomerAssets(investment_asset.customer_asset_id, investment_asset.asset_title, investment_asset.admin_value)"/></td>
                                            <td class="text-gray">{{parseFloat(investment_asset.admin_value).toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="investment_asset.admin_value" v-on:input="updateCustomerAssets(investment_asset.customer_asset_id, investment_asset.asset_title, investment_asset.admin_value)">
                                                    <template #append>
                                                        <base-button type="primary" icon size="sm" @click.prevent="deleteCustomerAssets(investment_asset.customer_asset_id)">
                                                            <span class="fas fa-trash"></span>
                                                        </base-button>
                                                    </template>
                                                </el-input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pl-4"><b>Total Investment Assets</b></td>
                                            <td><b>{{totalAssetAdminValue.investment_assets.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{totalAssetAdminValue.investment_assets.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </tr>
                                    </template>
                                    
                                    <template>
                                        <tr>
                                            <td colspan="3" class="pl-4"><b>Personal Use Assets</b>&nbsp;
                                                <base-button type="primary" icon size="sm" @click.prevent="addCustomerAssets('personal_assets')">
                                                    <span class="btn-inner--icon"><i class="fa fa-plus"></i></span>
                                                </base-button>
                                            </td>
                                        </tr>
                                        <tr v-for="(personal_asset) in assets.personal_assets" :key="'asset_'+personal_asset.customer_asset_id">
                                            <td><el-input type="text" min="0" size="small" id="admin-value" v-model="personal_asset.asset_title" v-on:input="updateCustomerAssets(personal_asset.customer_asset_id, personal_asset.asset_title, personal_asset.admin_value)"/></td>
                                            <td class="text-gray">{{parseFloat(personal_asset.admin_value).toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="personal_asset.admin_value" v-on:input="updateCustomerAssets(personal_asset.customer_asset_id, personal_asset.asset_title, personal_asset.admin_value)">
                                                    <template #append>
                                                        <base-button type="primary" icon size="sm" @click.prevent="deleteCustomerAssets(personal_asset.customer_asset_id)">
                                                            <span class="fas fa-trash"></span>
                                                        </base-button>
                                                    </template>
                                                </el-input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pl-4"><b>Total Personal Use Assets</b></td>
                                            <td><b>{{totalAssetAdminValue.personal_assets.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{totalAssetAdminValue.personal_assets.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td><b>Total Assets</b></td>
                                        <td><b>{{netWorthAdmin.asset.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{netWorthAdmin.asset.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <!-- liabilities -->
                                <template>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td colspan="3"><b>Liabilities - from IM2U</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="3"><b>Liabilities</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="pl-4"><b>Current Liabilities</b></td>
                                    </tr>
                                    <template v-for="fixedExpense in fixedExpenses.customer_liabilities_data">
                                        <tr :key="'fixExpense_'+fixedExpense.customer_liability_id" v-if="fixedExpense.loan_statue != 'HSLNFNCE' && fixedExpense.loan_statue != 'PCPASCAR'">
                                            <td class="pl-5">{{fixedExpense.loan_statue_name}}</td>
                                            <td>{{fixedExpense.customer_curr_outstanding.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="fixedExpense.admin_curr_outstanding" v-on:input="updateFixedExpenseAdminValue(fixedExpense.customer_liability_id, fixedExpense.admin_curr_outstanding)"></el-input>
                                            </td>
                                        </tr>
                                    </template>
                                    
                                    <tr>
                                        <td class="pl-4"><b>Total Current Liabilities</b> </td>
                                        <td><b>{{fixedExpenses.total.total_customer_current_liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalLiabilityAdminValue["current"].toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="pl-4"><b>Long Term Liabilities</b></td>
                                    </tr>
                                    <template v-for="fixedExpense in fixedExpenses.customer_liabilities_data" >
                                        <tr :key="'fixedExpense_'+fixedExpense.customer_liability_id" v-if="fixedExpense.loan_statue == 'HSLNFNCE' || fixedExpense.loan_statue == 'PCPASCAR'">
                                            <td class="pl-5">{{fixedExpense.loan_statue_name}}</td>
                                            <td>{{fixedExpense.customer_curr_outstanding.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="fixedExpense.admin_curr_outstanding" v-on:input="updateFixedExpenseAdminValue(fixedExpense.customer_liability_id, fixedExpense.admin_curr_outstanding)"></el-input>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td class="pl-4"><b>Total Long Term Liabilities</b> </td>
                                        <td><b>{{fixedExpenses.total.total_customer_long_term_liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalLiabilityAdminValue["long_term"].toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <tr>
                                        <td><b>Total Liabilities</b> </td>
                                        <td><b>{{(fixedExpenses.total.total_customer_current_liability+fixedExpenses.total.total_customer_long_term_liability).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{netWorthAdmin.liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <tr>
                                    <td><b>Net Worth</b></td>
                                    <template v-if="netWorthAdmin.total.customer_value < 0">
                                        <td class="text-red"><b>({{Math.abs(netWorthAdmin.total.customer_value).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                    </template>
                                    <template v-else>
                                        <td><b>{{netWorthAdmin.total.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </template>
                                    <template v-if="netWorthAdmin.total.admin_value < 0">
                                        <td class="text-red"><b>({{Math.abs(netWorthAdmin.total.admin_value).toLocaleString(undefined, {minimumFractionDigits: 2})}})</b></td>
                                    </template>
                                    <template v-else>
                                        <td><b>{{netWorthAdmin.total.admin_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </template>
                                </tr>
                            </table> 
                        </div>
                        <el-table class="bank-eligibility table-responsive align-items-center table-flush"
                                    header-row-class-name="thead-light"
                                    :data="queriedData"
                                    @sort-change="sortChange"
                                    :default-sort="{ prop: 'Bank_Name', order: 'ascending' }"
                                    highlight-current-row
                                    @current-change="handleCurrentChange"
                                    row-key="id">
                            <el-table-column label="Name"
                                            min-width="120px"
                                            prop="Bank_Name"
                                            sortable>
                                <template v-slot="{row}">
                                <b>{{row.Bank_Name}}</b>
                                </template>
                            </el-table-column>

                            <!-- <el-table-column label="Credit Behaviour"
                                            min-width="100px"
                                            prop="Fintos_Score"
                                            sortable>
                                <template v-slot="{row}">
                                <b>{{row.Fintos_Score}}</b>
                                </template>
                            </el-table-column> -->

                            <el-table-column label="Estimated Best Rate (%)"
                                            min-width="120px"
                                            prop="Loan_Interest"
                                            sortable>
                                <template v-slot="{row}">
                                <b style="padding-left:50px">{{parseFloat(row.Loan_Interest).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b>
                                </template>
                            </el-table-column>

                            <el-table-column label="Eligibility Amount (RM)"
                                            min-width="120px"
                                            prop="Loan_Eligible"
                                            sortable>
                                <template v-slot="{row}">
                                    <b-col>
                                        <b-row style="padding-left:50px">
                                            <b-img width="20px" fluid src="/img/bank_score_recommended_v2.png"></b-img>&nbsp;
                                            <b>{{parseFloat(row.Loan_Eligible).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b>
                                        </b-row>
                                    </b-col>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="90px">
                                <template v-slot="{row}" v-if="selects.bank">
                                    <base-button type="primary" size="sm" v-show="row.Bank_Id == selects.bank.bank_id" class="disabled">selected</base-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <div>This Function / Module is currently Under Development, Please come back later.</div> -->
                    </b-collapse>
                </card>
            </b-col>
        </b-row>
        <!-- <b-container id="capture" :style="[loginUser.role_id == 1 || loginUser.role_id == 2 ? {'display':'block'} : {'display':'none'}]"> -->
        <b-container id="capture">
            <apexchart type="pie" width="400" :options="chartOptions" :series="series"></apexchart>
        </b-container>
    </div>
</template>
<script>
    import { Table, TableColumn, Select , Option } from 'element-ui'
    import axios from 'axios'
    import {apiDomain, getHeader} from '@/assets/js/config.js'
    
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import swal from 'sweetalert2';
    import 'sweetalert2/dist/sweetalert2.css';
    import cashIncomes from './demo/cashincomes';
    // import loanEligibilities from './loaneligibilities';
    // import fixedExpensesData from './fixedexpenses';
    // import customerAssets from './assets';
    import {getUserInfo} from '@/assets/js/config.js'
    import debounce from 'lodash.debounce';
    import VueApexCharts from 'vue-apexcharts';

    export default {
        mixins: [clientPaginationMixin],
        props: ["net_flow", "input_saving_info_from_user"],
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            "apexchart": VueApexCharts,
        },
        data() {
            return {
                loginUser : getUserInfo(),
                cashIncomes,
                customers: {},
								saving_info_from_user:saving_info_from_user,
                fixedExpensesData: {
                    total: {
                        total_customer_current_liability: 0,
                        total_customer_long_term_liability: 0,
                    }
                },
                customerAssets: {
                    cash_equivalents: [],
                    investment_assets: [],
                    personal_assets: [],
                },
                tableData: [],
                selectedRows: [],
                selects:{
                    bank:[],
                },
                uniqueSubCategories: [],
                assetAdminValue: [],
                totalAssetAdminValue: {
                    cash_equivalents: 0,
                    investment_assets: 0,
                    personal_assets: 0,
                },
                netWorthAdmin: {
                    asset: 0,
                    liability: 0,
                    total: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                },
                liabilityAdminValue: [],
                totalLiabilityAdminValue: {
                    current: 0,
                    long_term: 0,
                },
                isSelected: false,
                series: [],
                chartOptions: {
                    chart: {
                        type: 'pie',
                    },
                    responsive: [
                        {
                            breakpoint: 50,
                            options: {
                                chart: {
                                    width: 200
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        },
                        {
                            breakpoint: 100,
                            options: {
                                chart: {
                                    width: 350
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        },
                        {
                            breakpoint: 500,
                            options: {
                                chart: {
                                    width: 350
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        },
                        {
                            breakpoint: 1000,
                            options: {
                                chart: {
                                    width: 400
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        },
                        {
                            breakpoint: 2000,
                            options: {
                                chart: {
                                    width: 400,
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        },
                        {
                            breakpoint: 3000,
                            options: {
                                chart: {
                                    width: 500
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        },
                        {
                            breakpoint: 5000,
                            options: {
                                chart: {
                                    width: 500
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        },
                    
                    ],
                    labels: [],
                    tooltip: {
                        fillSeriesColor: false,
                    },
                    theme: {
                        palette: 'palette10', 
                        monochrome: {
                            enabled: true,
                            color: '#770be3',
                            shadeTo: 'dark',
                        },
                    },
                },
                chartImage: null,
            };
        },
        created() {
            // this.initialAsset();
            this.getCustomerInfo();
            this.getSelectedEligibilityData();
            this.getCustomerAssetData();
            this.getCustomerLiabilityData();
            this.getCustomerEligibilityData();
            // below code needed to run the computed and watch on created
            // this.customerAssets = {...customerAssets};
            // this.fixedExpensesData = {...fixedExpensesData};   
        },
        computed:{
            assets() {
                const {customerAssets} = this
                return customerAssets
            },
            fixedExpenses() {
                const {fixedExpensesData} = this
                return fixedExpensesData
            }
            
        },
        watch: {
            assets: {
                handler: function(val) {
                    let totalAssetAdminValue = {
                        cash_equivalents: 0,
                        investment_assets: 0,
                        personal_assets: 0,
                    };
                   
                    if(val.cash_equivalents)
                    {
                        // cash equivalents
                        val.cash_equivalents.filter(function(data, idx) {
                            totalAssetAdminValue.cash_equivalents += parseFloat(data.admin_value);
                        });
                    }

                    if(val.investment_assets)
                    {
                        // investment assets
                        val.investment_assets.filter(function(data, idx) {
                            totalAssetAdminValue.investment_assets += parseFloat(data.admin_value);
                        });
                    }
                    
                    if(val.personal_assets)
                    {
                        // personal use assets
                        val.personal_assets.filter(function(data, idx) {
                            totalAssetAdminValue.personal_assets += parseFloat(data.admin_value);
                        });
                    }

                    this.totalAssetAdminValue = totalAssetAdminValue;
                    
                    this.getNetWorth();
                },
                deep: true,
            },
            fixedExpenses: {
                handler: function(val) {
                    let liabilityAdminValue = this.liabilityAdminValue
                    let totalLiabilityAdminValue = this.totalLiabilityAdminValue;
                    val.customer_liabilities_data.filter( function( data, idx ) {
                        if(data.loan_statue == "HSLNFNCE" || data.loan_statue == "PCPASCAR") 
                        {
                            liabilityAdminValue['long_term'] = {
                                ...liabilityAdminValue['long_term'],
                                [data.customer_liability_id]: parseFloat(data.admin_curr_outstanding)
                            };
                            totalLiabilityAdminValue['long_term'] = 0;
                        }
                        else
                        {
                            liabilityAdminValue['current'] = {
                                ...liabilityAdminValue['current'],
                                [data.customer_liability_id]: parseFloat(data.admin_curr_outstanding)
                            };
                            totalLiabilityAdminValue['current'] = 0;
                        }
                    });
                    Object.keys(liabilityAdminValue).forEach((key) => {
                        Object.values(liabilityAdminValue[key]).forEach((data) => {
                            if(isNaN(data))
                            {
                                data = 0;
                            }
                            totalLiabilityAdminValue[key] += data;
                        });                    
                    });     
                    this.getNetWorth();
                },
                deep: true,
            },
        },
        methods: {
            handleCurrentChange(selectedRow){
                this.$notify({
                    message: '<b>' + selectedRow.Bank_Name + ' is selected as the recommended bank for this customer.</b>',
                    timeout: 1500,
                    icon: 'ni ni-bulb-61',
                    type: 'success',
                });
                this.selects.bank = selectedRow;
                this.getNetWorth();
                const postData = {
                    financial_proposal_id: this.$route.params.financial_proposal_id,
                    im2u_request_id: selectedRow.Request_Id,
                    bank_id: selectedRow.Bank_Id,
                    bank_name: selectedRow.Bank_Name,
                    // fintos_score: selectedRow.Fintos_Score,
                    loan_interest: selectedRow.Loan_Interest,
                    loan_eligible: selectedRow.Loan_Eligible,
                }

                axios.post(apiDomain + 'financial_proposal/customer_eligibility', postData,{ headers: getHeader() })
                .then ( response => {
                    this.getSelectedEligibilityData();
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Update Customer Eligibility")
                });
            },
            close() {
                this.$router.back();
            },
            getCustomerInfo()
            {
                axios.get(apiDomain + 'financial_proposal/financial_proposal/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.customers = response.data.data[0]
                    }
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Show Customer Income")
                });
            },
            getCustomerLiabilityData() {
                axios.get(apiDomain + 'financial_proposal/get_customer_liability/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.fixedExpensesData = response.data
                        this.generateChart();
                    }
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Show Customer Liability")
                });
            },
            updateFixedExpenseAdminValue: debounce(function(customer_liability_id, curr_outstanding) {
                const postData = {
                    admin_curr_outstanding : curr_outstanding,
                }
                axios.put(apiDomain + 'financial_proposal/customer_liability/' + customer_liability_id, postData, { headers: getHeader() })
                .then(response => {
                    this.generateChart();
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error, "Error Saving Admin Value") 
                });
            },1000),
            getCustomerEligibilityData() {
                axios.get(apiDomain + 'financial_proposal/get_customer_loan_eligibility_from_im2u/' + this.$route.params.customer_id ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.tableData = response.data.data;
                    }
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Show Customer Bank Eligibility")
                });
            },
            getSelectedEligibilityData() {
                axios.get(apiDomain + 'financial_proposal/get_customer_loan_eligibility_by_financial_proposal_id/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                    this.selects.bank = response.data.data[0];
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Get Customer Loan Eligibility")
                });
            },
            async getCustomerAssetData() {
                return axios.get(apiDomain + 'financial_proposal/get_customer_asset_by_financial_proposal_id/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
                .then ( response => {
                    this.customerAssets = response.data;
                    Object.values(this.customerAssets.cash_equivalents).forEach((data) => {
                        if(data.asset_title == "saving from net flow value")
                        {
                            if(data.admin_value != this.net_flow.annual_total_netflow.toFixed(2))
                            {
                                this.saving_info_from_user = true;
                            }
                            else
                            {
                                this.saving_info_from_user = false;
                            }
                        }
                    });
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Get Customer Assets")
                });
            },
            async saveNetFlowDataToCustomerAssets() {
                const postData = {
                    financial_proposal_id : this.$route.params.financial_proposal_id,
                    asset_type_id: 1,
                    asset_title: "saving from net flow value",
                    admin_value: this.net_flow.annual_total_netflow,
                }
                const str = JSON.stringify(postData);
                
                await axios.post(apiDomain + 'financial_proposal/customer_asset', postData ,{ headers: getHeader() })
                .then ( response => {
                    this.getCustomerLiabilityData();
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Create Customer Asset")
                });

                await this.getCustomerAssetData();
            },
            resetCustomerSavingAsset(asset_type_id, asset_title, admin_value) {
                const postData = {
                    asset_title: asset_title,
                    admin_value: admin_value,
                }

                axios.put(apiDomain + 'financial_proposal/customer_asset/' + asset_type_id, postData ,{ headers: getHeader() })
                .then ( response => {
                    this.saving_info_from_user = false;
                    this.getCustomerAssetData();
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Add Customer Asset")
                });
            },
            async addCustomerAssets(asset_type_name) {
                let asset_type_id;
                this.customerAssets[asset_type_name].push({admin_value: 0});
                length = Object.keys(this.customerAssets[asset_type_name]).length;
                switch(asset_type_name)
                {
                    case 'cash_equivalents':
                        asset_type_id = 1;
                        break;
                    case 'investment_assets':
                        asset_type_id = 2;
                        break;
                    case 'personal_assets':
                        asset_type_id = 3;
                        break;
                }
                const postData = {
                    financial_proposal_id : this.$route.params.financial_proposal_id,
                    asset_type_id: asset_type_id,
                    asset_title: asset_type_name + ' ' + length,
                    admin_value: 0,
                }
                const str = JSON.stringify(postData);
                 
                await axios.post(apiDomain + 'financial_proposal/customer_asset', postData ,{ headers: getHeader() })
                .then ( response => {
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Update Customer Asset")
                });

                await this.getCustomerAssetData();
                
            },
            updateCustomerAssets: debounce(function(asset_type_id, asset_title, admin_value)
            {
                if(!asset_title)
                {
                    _gNotif.redErrorNotify( '<b>Invalid Input : Asset Title is Mandatory </b>')
                }
                else
                {   
                    if(asset_title == 'saving from net flow value')
                    {
                        if(admin_value != this.net_flow.annual_total_netflow)
                        {
                            this.saving_info_from_user = true;
                        }
                        else
                        {
                            this.saving_info_from_user = false;
                        }
                    }
                    const postData = {
                        asset_title: asset_title,
                        admin_value: admin_value,
                    }

                    axios.put(apiDomain + 'financial_proposal/customer_asset/' + asset_type_id, postData ,{ headers: getHeader() })
                    .then ( response => {
                    })
                    .catch ( error => {
                         
                        _gNotif.errorFunction(error,null, "Add Customer Asset")
                    });
                }
            },1000),
            deleteCustomerAssets(customer_asset_id) {
                // this.customerAssets[asset_type_name].splice(index, 1);
                axios.delete(apiDomain + 'financial_proposal/customer_asset/' + customer_asset_id,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.$notify({
                            message:
                                '<b>Customer Asset Successfully Deleted.',
                            timeout: 10000,
                            icon: 'ni ni-bell-55',
                            type: 'default',
                        });

                        this.getCustomerAssetData();
                    }
                })
                .catch ( error => {
                     
                    _gNotif.errorFunction(error,null, "Delete Customer Asset")
                    
                });
            },
            initialAsset() {
                let uniqueCategory= [];
                let uniqueSubCategory= [];
                let totalAssetAdminValue = [];
                Object.values(customerAssets[0].customer_assets).forEach((data) => {
                    
                    // set category
                    if(uniqueCategory.indexOf(data.customer_template_category.customer_category_name) < 0)
                    {
                        uniqueCategory[data.customer_template_category.customer_category_sort] = data.customer_template_category.customer_category_name;
                    }
                    if(uniqueSubCategory.indexOf(data.customer_template_category.customer_sub_category_name) < 0)
                    {
                        uniqueSubCategory[data.customer_template_category.customer_sub_category_sort] = data.customer_template_category.customer_sub_category_name;
                        totalAssetAdminValue[data.customer_template_category.customer_sub_category_name] = 0;
                    }
                });
                this.uniqueSubCategories = uniqueSubCategory;
                this.totalAssetAdminValue = totalAssetAdminValue;  
 
            },
            getTotalAsset() {
                this.netWorthAdmin.asset = 0;
                Object.values(this.totalAssetAdminValue).forEach((data) => {
                    this.netWorthAdmin.asset += data;
                });
            },
            getTotalLiability() {
                this.netWorthAdmin.liability = 0;
                Object.values(this.totalLiabilityAdminValue).forEach((data) => {
                    this.netWorthAdmin.liability += data;
                });
            },
            generateChart() {
                let loan_statue_array = [];
                this.series = [];
                if(this.fixedExpensesData.customer_liabilities_data)
                {
                    Object.values(this.fixedExpensesData.customer_liabilities_data).forEach((data) => {
                        loan_statue_array.push(data.loan_statue_name);
                        if(data.admin_curr_outstanding != null && data.admin_curr_outstanding != 0)
                        {
                            this.series.push(data.admin_curr_outstanding * 1);
                        }
                        else
                        {
                            this.series.push(data.customer_curr_outstanding * 1);
                        }
                    });

                    if(this.series.length > 4)
                    {
                        // set chart size
                        this.chartOptions = {
                            responsive: [
                                {
                                    breakpoint: 2000,
                                    options: {
                                        chart: {
                                            width: 500
                                        },
                                        legend: {
                                            position: 'bottom'
                                        }
                                    }
                                },
                                {
                                    breakpoint: 3000,
                                    options: {
                                        chart: {
                                            width: 500
                                        },
                                        legend: {
                                            position: 'bottom'
                                        }
                                    }
                                },
                                {
                                    breakpoint: 5000,
                                    options: {
                                        chart: {
                                            width: 500
                                        },
                                        legend: {
                                            position: 'bottom'
                                        }
                                    }
                                },
                            ],
                            
                        }
                    }
                    
                    this.chartOptions = {
                        ...this.chartOptions,
                        labels: loan_statue_array,
                        legend: {
                            formatter: function(val, opts) {
                                return val + " - RM " + parseFloat(opts.w.globals.series[opts.seriesIndex]).toLocaleString(undefined, {minimumFractionDigits: 2})
                            }
                        }
                    };
                }
            },
            getNetWorth() {
                this.getTotalAsset();
                this.getTotalLiability();
                let netWorth = {
                    customer_value: this.netWorthAdmin.asset - (this.fixedExpenses.total.total_customer_current_liability+this.fixedExpenses.total.total_customer_long_term_liability),
                    admin_value: this.netWorthAdmin.asset - this.netWorthAdmin.liability,
                };
                this.netWorthAdmin = {...this.netWorthAdmin, total: netWorth}

                if(this.selects.bank == undefined)
                {
                    this.selects.bank = [];
                }

                const netWorthStatementData = {
                    assets: this.netWorthAdmin.asset,
                    liabilities: {
                        ...this.fixedExpenses.customer_liabilities_data,
                    },
                    net_worth: this.netWorthAdmin.total,
                    selectedBank: this.selects.bank,
                }

                this.$emit('net-worth-statement-data', netWorthStatementData);
                
            },
        }
    };
</script>
<style scoped>
table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

td , th {
    border: 1px solid #dddddd;
    text-align: center;
    /* height: 10px; */
    /* width: 20%; */
}

td:first-child {
    text-align: left;
    padding-left: 8px;
}

th {
    background-color: #525f7f;
    font-size: large;
    width: 20%;
}

.button-right {
    padding-right: 0;
}
</style>
<style>
#admin-value {
    text-align:center;
    font-size:medium;
}
.el-table__body tr.current-row>td.el-table__cell {
    background-color: #87f6a4;
}
.el-table__row:hover
{
    background-color: #eaecef !important;
}
.bank-eligibility thead th {
    font-size: .845rem !important;
}
.bank-eligibility td {
    font-size: 1rem !important;
}
</style>